<button class="btn btn-primary float-right retry-button" (click)="retryPayment()" *ngIf="statusFailed">
  Retry Payment
</button>
<acx-order-details [order]="order?.order" [deliveryMethod]="order?.delivery_method"></acx-order-details>
<div *ngIf="delivered" class="my-5">
  <h3 class="headings">Delivery Date</h3>
  <span>{{ delivery_date }}</span>
</div>
<app-order-address [order]="order"></app-order-address>
